import React from 'react';
import { ArrowRight } from 'lucide-react';
import { text, buttonHref } from './siteUtils';
import { RichText, useFieldStyle } from './Typography';
import { backgroundDisplayStyle, useImageDevice } from '../../utils/imageDisplay';
import { mediaUrl } from './siteUtils';

export const SiteLink = ({ href, children, className = '', testId, newTab, ...props }) => (
  <a href={href} className={className} data-testid={testId} target={newTab ? '_blank' : undefined} rel={newTab ? 'noopener noreferrer' : undefined} {...props}>{children}</a>
);

export const BlockButton = ({ content, id, secondary = false }) => {
  const styles = useFieldStyle('button', content.textStyles);
  const label = secondary ? content.secondaryButtonText : content.buttonText || content.button_text;
  const href = secondary ? content.secondaryButtonLink : buttonHref(content);
  if (!label || !href || (!secondary && content.buttonEnabled === false)) return null;
  return <SiteLink href={href} newTab={!secondary && content.buttonNewTab} testId={`${id}-${secondary ? 'secondary' : 'primary'}-cta`} style={styles} className={secondary ? 'tdp-text-link' : 'tdp-button'}>{text(label)}<ArrowRight size={18} aria-hidden="true" /></SiteLink>;
};

export const SectionHeading = ({ content, id }) => (
  <div className="tdp-section-heading">
    {content.eyebrow && <span className="tdp-eyebrow" data-testid={`${id}-eyebrow`}>{text(content.eyebrow)}</span>}
    {content.title && <RichText as="h2" field="title" testId={`${id}-title`} value={content.title} />}
    {content.subtitle && <RichText as="p" field="subtitle" testId={`${id}-subtitle`} value={content.subtitle} />}
  </div>
);

export const BlockSection = ({ block, children, className = '' }) => {
  const screen = useImageDevice();
  const c = block.content || {};
  const owner = block.backgroundImage ? block : c;
  const field = c.parallax && c.parallaxImage && !block.backgroundImage ? 'parallaxImage' : 'backgroundImage';
  const source = owner[field];
  return (
  <section id={block.anchorId || (block.type === 'contact' ? 'kontakt' : block.id)} data-testid={`section-${block.id}`} className={`tdp-section ${className}`} style={block.styleMode === 'individual' ? { backgroundColor: block.backgroundColor, color: block.contentColor, paddingTop: block.paddingTop, paddingBottom: block.paddingBottom } : undefined}>
    {source && <div className="tdp-section-background" data-testid={`${block.id}-background-image`} aria-hidden="true" style={{backgroundImage:`url("${mediaUrl(source)}")`,...backgroundDisplayStyle(owner,field,screen),opacity:(owner[`${field}Opacity`]??100)/100}} />}
    <div className="tdp-container">{children}</div>
  </section>
);
};